import { ref } from "vue"

// const API_BASE = import.meta.env.VITE_API_BASE || "/api"
const API_BASE = "/api"

function bboxKey(bbox) {
  return Array.isArray(bbox)
    ? bbox.map(n => Number(n).toFixed(5)).join(",")
    : ""
}

function makeCacheKey({ bbox, simplify, limit }) {
  return JSON.stringify({
    bbox: bboxKey(bbox),
    simplify: simplify ?? null,
    limit: limit ?? null,
  })
}

// shared cache outside the composable — persists across all instances
const cache = ref({})
const loadingByLayer = ref({})
const errorByLayer = ref({})

export function useGeoLayers() {
  // const cache = ref({})
  // const loadingByLayer = ref({})
  // const errorByLayer = ref({})

  async function fetchJson(url) {
    const res = await fetch(url, {
      headers: { Accept: "application/json" },
    })

    if (!res.ok) {
      throw new Error(`${url} HTTP ${res.status}`)
    }

    return res.json()
  }

  async function loadLayer(
    layerName,
    { bbox = null, simplify = null, limit = null, force = false } = {},
  ) {
 
    await new Promise(resolve => requestAnimationFrame(resolve)) // yield to browser first
    
     if (!layerName) return null

    const requestKey = makeCacheKey({ bbox, simplify, limit })
    const prev = cache.value[layerName]

    if (!force && prev?.requestKey === requestKey && prev?.data) {
      return prev.data
    }

    loadingByLayer.value = {
      ...loadingByLayer.value,
      [layerName]: true,
    }

    errorByLayer.value = {
      ...errorByLayer.value,
      [layerName]: null,
    }

    try {
      const qs = new URLSearchParams()

      if (bbox) qs.set("bbox", bbox.join(","))
      if (simplify != null) qs.set("simplify", String(simplify))
      if (limit != null) qs.set("limit", String(limit))

      const url = qs.toString()
        ? `${API_BASE}/layers/${layerName}?${qs.toString()}`
        : `${API_BASE}/layers/${layerName}`

      const data = await fetchJson(url)

      cache.value = {
        ...cache.value,
        [layerName]: {
          data,
          requestKey,
          bboxKey: bboxKey(bbox),
          simplify,
          limit,
          fetchedAt: Date.now(),
        },
      }

      return data
    } catch (e) {
      const msg = e?.message || String(e)

      errorByLayer.value = {
        ...errorByLayer.value,
        [layerName]: msg,
      }

      return null
    } finally {
      loadingByLayer.value = {
        ...loadingByLayer.value,
        [layerName]: false,
      }
    }
  }

  function getLayer(layerName) {
    return cache.value[layerName]?.data ?? null
  }

  function clearLayer(layerName) {
    const next = { ...cache.value }
    delete next[layerName]
    cache.value = next
  }

  function clearAll() {
    cache.value = {}
    loadingByLayer.value = {}
    errorByLayer.value = {}
  }

  return {
    loadLayer,
    getLayer,
    clearLayer,
    clearAll,
    cache,
    loadingByLayer,
    errorByLayer,
  }
}



// import { ref } from "vue"

// function bboxKey(bbox) {
//   return Array.isArray(bbox) ? bbox.map(n => Number(n).toFixed(5)).join(",") : ""
// }

// export function useGeoLayers() {
//   const loadingByLayer = ref({}) // { [layerName]: boolean }
//   const errorByLayer = ref({})   // { [layerName]: string | null }

//   // Cache:
//   // cache[layerName] = {
//   //   data: GeoJSON | null,
//   //   bboxKey: string,     // last bbox used
//   //   simplify: number|null,
//   //   fetchedAt: number
//   // }
//   const cache = ref({})

//   async function fetchJson(url) {
//     const res = await fetch(url, { headers: { Accept: "application/json" } })
//     if (!res.ok) throw new Error(`${url} HTTP ${res.status}`)
//     return res.json()
//   }

//   async function loadLayer(layerName, { bbox = null, simplify = null, limit = null, force = false } = {}) {
//     if (!layerName) return null

//     const key = bbox ? bboxKey(bbox) : ""
//     const prev = cache.value[layerName]

//     // Simple cache rule: if same bbox + simplify, skip (unless force)
//     if (!force && prev && prev.bboxKey === key && prev.simplify === simplify && prev.data) {
//       return prev.data
//     }

//     loadingByLayer.value = { ...loadingByLayer.value, [layerName]: true }
//     errorByLayer.value = { ...errorByLayer.value, [layerName]: null }

//     try {
//       const qs = new URLSearchParams()
//       if (bbox) qs.set("bbox", bbox.join(","))
//       if (simplify != null) qs.set("simplify", String(simplify))
//       if (limit != null) qs.set("limit", String(limit))

//       const url = qs.toString()
//         ? `/api/layers/${layerName}?${qs.toString()}`
//         : `/api/layers/${layerName}`

//       const data = await fetchJson(url)

//       cache.value = {
//         ...cache.value,
//         [layerName]: {
//           data,
//           bboxKey: key,
//           simplify,
//           fetchedAt: Date.now(),
//         },
//       }

//       return data
//     } catch (e) {
//       const msg = e?.message || String(e)
//       errorByLayer.value = { ...errorByLayer.value, [layerName]: msg }
//       return null
//     } finally {
//       loadingByLayer.value = { ...loadingByLayer.value, [layerName]: false }
//     }
//   }

//   function getLayer(layerName) {
//     return cache.value[layerName]?.data ?? null
//   }

//   function clearLayer(layerName) {
//     const next = { ...cache.value }
//     delete next[layerName]
//     cache.value = next
//   }

//   function clearAll() {
//     cache.value = {}
//     loadingByLayer.value = {}
//     errorByLayer.value = {}
//   }

//   return {
//     loadLayer,
//     getLayer,
//     clearLayer,
//     clearAll,
//     cache,
//     loadingByLayer,
//     errorByLayer,
//   }
// }